import { FC, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { QcsTypography } from './QcsTypography';
import { copyToClipboard } from '../../../utils/clipboard';
import { useTranslation } from 'react-i18next';
import DoneIcon from '@mui/icons-material/Done';

export interface QcsClickToCopyText {
  text: string;
}

export const QcsClickToCopyText: FC<QcsClickToCopyText> = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const [hovered, setHovered] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => {
    copyToClipboard(text).then(() => setCopied(true));
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Box
      sx={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <QcsTypography
        sx={{ marginRight: '1.5rem', marginTop: '1.5rem' }}
        variant="h4"
      >
        {text}
      </QcsTypography>
      {hovered && !copied && (
        <IconButton
          size="small"
          sx={{ position: 'absolute', right: 0, top: 0, opacity: 0.5 }}
        >
          <ContentCopyIcon />
        </IconButton>
      )}
      {copied && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            color: 'black',
            padding: '0.25rem',
            borderRadius: '4px',
            opacity: 0.5,
          }}
        >
          <DoneIcon />
          {t('common.copied')}
        </Box>
      )}
    </Box>
  );
};
